// Production API client -- per-segment speaker override (Vera Issue #4/#5)
// Types mirror scratch at src/lib/scratch/speaker-override-api.ts (SHA bb7aabb)
import { apiFetch } from "../api";

const API_BASE_RAW = (import.meta.env.VITE_API_URL as string) || "";

export interface SegmentOverrideResponse {
  ok: true;
  segment_id: string;
  new_speaker: string;
  speaker_audit_id: number;
  suggestion_count: number;
  status: "pending_review";
  idempotent?: boolean;
}

export interface SegmentOverrideClearResponse {
  ok: true;
  cleared: boolean;
}

export interface AdminSegmentOverrideResponse {
  ok: true;
  audit_id: number;
  segments_updated: number;
  user_overrides_cleared: number;
  effective_speaker: string;
}

export interface SuggestionCountResponse {
  flag_id: number;
  suggestion_count: number;
}

/** PUT /library/items/{itemId}/segments/{segmentId}/speaker-override */
export async function putSegmentSpeakerOverride(
  itemId: string,
  segmentId: string,
  newSpeaker: string,
): Promise<SegmentOverrideResponse> {
  return apiFetch<SegmentOverrideResponse>(
    "/library/items/" + encodeURIComponent(itemId) + "/segments/" + encodeURIComponent(segmentId) + "/speaker-override",
    {
      method: "PUT",
      body: JSON.stringify({ new_speaker: newSpeaker }),
    },
  );
}

/** DELETE /library/items/{itemId}/segments/{segmentId}/speaker-override */
export async function clearSegmentSpeakerOverride(
  itemId: string,
  segmentId: string,
): Promise<SegmentOverrideClearResponse> {
  return apiFetch<SegmentOverrideClearResponse>(
    "/library/items/" + encodeURIComponent(itemId) + "/segments/" + encodeURIComponent(segmentId) + "/speaker-override",
    { method: "DELETE" },
  );
}

/** POST /admin/segments/{segmentId}/speaker -- uses X-Admin-Key, bypasses apiFetch */
export async function adminOverrideSegmentSpeaker(
  segmentId: string,
  newSpeaker: string,
  adminKey: string,
): Promise<AdminSegmentOverrideResponse> {
  const r = await fetch(
    API_BASE_RAW + "/admin/segments/" + encodeURIComponent(segmentId) + "/speaker",
    {
      method: "POST",
      headers: { "Content-Type": "application/json", "x-admin-key": adminKey },
      body: JSON.stringify({ new_speaker: newSpeaker }),
    },
  );
  if (!r.ok) throw new Error("POST admin segment override failed: " + r.status);
  return r.json();
}

/** GET /admin/speaker-audit/{flagId}/suggestion-count -- uses X-Admin-Key */
export async function getSuggestionCount(
  flagId: number,
  adminKey: string,
): Promise<SuggestionCountResponse> {
  const r = await fetch(
    API_BASE_RAW + "/admin/speaker-audit/" + flagId + "/suggestion-count",
    { headers: { "x-admin-key": adminKey } },
  );
  if (!r.ok) throw new Error("GET suggestion-count failed: " + r.status);
  return r.json();
}
